<template>
    <NewButton
        :class="['EvieChatThreadJumpButton', { 'EvieChatThreadJumpButton--loading': loading }]"
        :size="loading ? 'sm' : 'icon-sm'"
        variant="outline"
        color="neutral"
        type="button"
        @click="$emit('click')"
    >
        <EvieChatThinking v-if="loading" :visible="true" class="EvieChatThreadJumpButton__thinking" />
        <EidIcon v-else :icon-src="faChevronDown" />
    </NewButton>
</template>

<style lang="scss">
.EvieChatThreadJumpButton {
    border-radius: 50% !important;
    pointer-events: auto;

    &--loading {
        border-radius: 24px !important;
    }

    &__thinking {
        padding: 0;
    }
}
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';

    import NewButton from '@/components/new-button/NewButton.vue';

    import EvieChatThinking from '../../EvieChatThinking/EvieChatThinking.vue';

    export default defineComponent({
        name: 'EvieChatThreadJumpButton',
        components: { NewButton, EidIcon, EvieChatThinking },
        props: {
            loading: { type: Boolean, default: false },
        },
        emits: [ 'click' ],
        data() {
            return { faChevronDown };
        },
    });
</script>
